module.exports = __webpack_public_path__ + "static/media/strategy.f83fae8b.jpg";